/*
  Ce qui donne vie au thème — et rien de plus.

  Cinq comportements, aucun cadre, aucune dépendance :
    1. les tracés à la main se dessinent quand ils entrent dans l'écran ;
    2. les blocs montent doucement à leur apparition ;
    3. le mot défilant se met en pause hors de l'écran, pour ne pas faire
       tourner une animation que personne ne regarde ;
    4. les textes longs se replient derrière un « Lire la suite » ;
    5. les pistes horizontales reçoivent leurs flèches — le défilement, lui,
       est natif et fonctionne sans script ;
    6. les panneaux du menu s'ouvrent au survol, sans qu'il faille cliquer.

  Principe de repli : sans JavaScript, tout est déjà visible. Ce fichier
  n'ajoute que du mouvement, jamais du contenu — une page qui ne s'anime pas
  reste une page complète.
*/

(() => {
  const moinsDeMouvement = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  /* ---------------------------------------------------------------- */
  /* 1. Les tracés se dessinent                                        */
  /* ---------------------------------------------------------------- */

  function preparerTrace(svg) {
    const path = svg.querySelector('path');
    if (!path) return;
    // getTotalLength échoue si le SVG n'est pas encore mis en page.
    let longueur = 0;
    try {
      longueur = path.getTotalLength();
    } catch {
      return;
    }
    if (!longueur) return;
    path.style.strokeDasharray = `${longueur}`;
    path.style.strokeDashoffset = `${longueur}`;
    svg.dataset.mloTracePret = 'true';
  }

  function dessiner(svg) {
    const path = svg.querySelector('path');
    if (!path) return;
    path.style.transition = 'stroke-dashoffset 900ms cubic-bezier(.2,.7,.3,1)';
    path.style.strokeDashoffset = '0';
    svg.dataset.mloTraceFait = 'true';
  }

  /* ---------------------------------------------------------------- */
  /* 2. Les blocs montent                                              */
  /* ---------------------------------------------------------------- */

  function apparaitre(element) {
    element.dataset.mloVu = 'true';
  }


  /* ---------------------------------------------------------------- */
  /* 4. Les textes longs se replient                                   */
  /* ---------------------------------------------------------------- */

  /*
    Un texte de collection fait quatre cents mots. Il doit etre la — pour le
    lecteur qui hesite, et pour le moteur — sans repousser la grille de
    produits de deux ecrans pour celui qui a deja choisi.

    LE TEXTE EST ENTIER DANS LE HTML DES LE DEPART. Ce n'est qu'un masque
    visuel : rien n'est charge apres coup. Un texte qu'un robot ne voit pas
    est un texte qu'on n'a pas ecrit.

    Le bouton est cree ICI, par le script. Sans JavaScript il n'existe pas,
    et le texte reste deplie : jamais de bouton mort, jamais de contenu
    coupe qu'on ne saurait pas remontrer.
  */
  function replier(bloc) {
    const corps = bloc.querySelector('[data-mlo-deplier-corps]');
    if (!corps) return;

    // Rien a replier si le texte tient deja dans la hauteur du masque.
    const seuil = 16 * 10; // 16rem, en pixels a la taille de base
    if (corps.scrollHeight <= seuil + 40) return;

    bloc.dataset.replie = 'true';

    const bouton = document.createElement('button');
    bouton.type = 'button';
    bouton.className = 'mlo-coll-pied__bouton';
    bouton.setAttribute('aria-expanded', 'false');
    bouton.setAttribute('aria-controls', corps.id || 'mlo-texte-long');
    if (!corps.id) corps.id = 'mlo-texte-long';

    const libelle = document.createElement('span');
    libelle.textContent = 'Lire la suite';
    bouton.appendChild(libelle);
    bouton.insertAdjacentHTML(
      'beforeend',
      '<svg viewBox="0 0 12 8" fill="none" aria-hidden="true"><path d="M1 1.5 6 6.5l5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>'
    );

    bouton.addEventListener('click', () => {
      const replie = bloc.dataset.replie === 'true';
      bloc.dataset.replie = replie ? 'false' : 'true';
      bouton.setAttribute('aria-expanded', replie ? 'true' : 'false');
      libelle.textContent = replie ? 'Replier' : 'Lire la suite';
    });

    bloc.appendChild(bouton);
  }


  /* ---------------------------------------------------------------- */
  /* 5. Les pistes horizontales recoivent leurs fleches                */
  /* ---------------------------------------------------------------- */

  /*
    LE DEFILEMENT LUI-MEME EST NATIF. scroll-snap et overflow-x suffisent :
    le doigt et la molette fonctionnent sans une ligne de script. Ces fleches
    ne servent qu'a la souris, sur un ecran large ou l'on ne fait pas glisser
    au doigt.

    Elles sont donc creees ICI. Sans JavaScript elles n'existent pas, et rien
    n'est perdu — c'est la difference entre une commande absente et une
    commande morte.

    Elles se desactivent aux deux bouts : une fleche qui ne fait rien quand
    on clique dessus est pire que pas de fleche du tout.
  */
  function equiperPiste(piste) {
    const commandes = piste
      .closest('[class*="__inner"], section, div')
      ?.querySelector('[data-mlo-glisser-commandes]');
    if (!commandes) return;

    // Rien a faire si tout tient deja dans la largeur.
    if (piste.scrollWidth <= piste.clientWidth + 8) return;

    const fleche = (sens, libelle) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'mlo-proches__fleche';
      b.setAttribute('aria-label', libelle);
      b.innerHTML =
        '<svg viewBox="0 0 34 10" fill="none" aria-hidden="true"><path d="M0 5h31M27 1l5 4-5 4" stroke="currentColor" stroke-width="1.4"/></svg>';
      if (sens < 0) b.querySelector('svg').style.transform = 'scaleX(-1)';
      b.addEventListener('click', () => {
        // On avance d'une carte et demie : assez pour changer de vue, pas
        // assez pour perdre le fil de ce qu'on regardait.
        const pas = piste.clientWidth * 0.6;
        piste.scrollBy({ left: sens * pas, behavior: 'smooth' });
      });
      return b;
    };

    const gauche = fleche(-1, 'Voir les livres precedents');
    const droite = fleche(1, 'Voir les livres suivants');
    commandes.append(gauche, droite);
    commandes.hidden = false;

    const majEtats = () => {
      const max = piste.scrollWidth - piste.clientWidth - 2;
      gauche.disabled = piste.scrollLeft <= 2;
      droite.disabled = piste.scrollLeft >= max;
    };
    piste.addEventListener('scroll', majEtats, { passive: true });
    majEtats();
  }

  /* ---------------------------------------------------------------- */
  /* Observation commune                                               */
  /* ---------------------------------------------------------------- */


  /* ---------------------------------------------------------------- */
  /* 6. Le menu s'ouvre au survol                                      */
  /* ---------------------------------------------------------------- */

  /*
    Dawn n'ouvre ses panneaux qu'au clic. Sur un menu de catalogue, c'est un
    geste de trop : on survole pour voir ce qu'il y a dedans, on ne clique que
    pour choisir.

    TROIS PRECAUTIONS, ET CHACUNE REPARE UN DEFAUT REEL DU SURVOL :

    1. Seulement a la souris. `(hover: hover) and (pointer: fine)` ecarte les
       ecrans tactiles, ou un « survol » est en realite un premier appui : le
       panneau s'ouvrirait puis se refermerait aussitot sous le doigt.

    2. Un delai a l'ouverture. Sans lui, traverser la barre pour atteindre le
       panier ouvre et referme chaque panneau au passage — un clignotement que
       personne n'a demande. Quatre-vingts millisecondes suffisent a
       distinguer une intention d'un trajet.

    3. Un delai plus long a la fermeture. La souris quitte forcement l'entree
       pour descendre vers le panneau, et passe par quelques pixels qui
       n'appartiennent ni a l'une ni a l'autre. Sans ce sursis, le panneau se
       ferme entre les deux.

    Le clic et le clavier continuent de fonctionner : on ne fait qu'ouvrir et
    fermer le meme `details` que Dawn manipule.
  */

  function equiperSurvolMenu() {
    const souris = window.matchMedia('(hover: hover) and (pointer: fine)');
    const grandEcran = window.matchMedia('(min-width: 990px)');

    document.querySelectorAll('header-menu').forEach((bloc) => {
      if (bloc.dataset.mloSurvol === 'true') return;
      bloc.dataset.mloSurvol = 'true';

      const details = bloc.querySelector('details');
      if (!details) return;

      let ouvrir = null;
      let fermer = null;

      const annuler = () => {
        clearTimeout(ouvrir);
        clearTimeout(fermer);
      };

      bloc.addEventListener('mouseenter', () => {
        if (!souris.matches || !grandEcran.matches) return;
        annuler();
        ouvrir = setTimeout(() => {
          // Un seul panneau a la fois : deux ouverts se recouvrent.
          document.querySelectorAll('header-menu details[open]').forEach((autre) => {
            if (autre !== details) autre.removeAttribute('open');
          });
          details.setAttribute('open', '');
        }, 80);
      });

      bloc.addEventListener('mouseleave', () => {
        if (!souris.matches || !grandEcran.matches) return;
        annuler();
        fermer = setTimeout(() => details.removeAttribute('open'), 220);
      });

      // Un clic reste un clic : il ne doit pas se battre avec le minuteur.
      bloc.addEventListener('click', annuler);
    });
  }

  function activer() {
    const traces = document.querySelectorAll('.mlo-trace');
    const montants = document.querySelectorAll('[data-mlo-monte]');
    const rotations = document.querySelectorAll('.mlo-rotation__piste');

    // Le repli ne depend ni du defilement ni du mouvement : on l'applique
    // toujours, y compris sous prefers-reduced-motion.
    document.querySelectorAll('[data-mlo-deplier]').forEach(replier);
    document.querySelectorAll('[data-mlo-glisser]').forEach(equiperPiste);

    // Le survol du menu n'est pas du mouvement mais de la navigation : il
    // s'applique aussi sous prefers-reduced-motion, ou seule l'animation du
    // panneau est neutralisee — par la feuille de style.
    equiperSurvolMenu();

    if (moinsDeMouvement.matches) {
      // Rien ne bouge : on montre tout, tout de suite.
      traces.forEach((svg) => {
        svg.dataset.mloTraceFait = 'true';
      });
      montants.forEach(apparaitre);
      return;
    }

    /*
      ON NE PREPARE PLUS LES DIX-NEUF TRACES D'UN COUP.

      Cette ligne disait `traces.forEach(preparerTrace)`, au chargement du
      document. Or `preparerTrace` lit `getTotalLength()` puis ecrit aussitot
      `strokeDasharray` et `strokeDashoffset` : l'ecriture invalide la mise en
      page, et la lecture suivante force le navigateur a la recalculer. Dix-neuf
      fois de suite, sur l'accueil. Le catalogue, lui, n'en porte aucune, et
      c'est une des differences qui le rendent deux fois plus rapide.

      Mesure Lighthouse du 10/09/2026 : 250,6 ms de fil principal pour un
      fichier de 12,5 ko, dont seulement 123,3 ms d'execution reelle. Le reste
      est du recalcul force. Le document est pret a 1 083 ms, la premiere
      peinture a lieu a 2 395 ms : tout ce qui s'execute la retarde le LCP.

      Chaque trace se prepare desormais au moment ou elle approche de l'ecran,
      une par une, dans un observateur qui existait deja pour les dessiner.
      Le cout ne disparait pas, il quitte le chemin critique et se disperse.

      IL FAUT UNE IMAGE ENTRE LA PREPARATION ET LE DESSIN. `preparerTrace` pose
      l'etat initial, `dessiner` pose l'etat final avec une transition : faites
      dans la meme image, le navigateur n'a jamais peint le depart et
      n'anime rien. `requestAnimationFrame` garantit ce temps.
    */
    if (!('IntersectionObserver' in window)) {
      traces.forEach((svg) => {
        preparerTrace(svg);
        dessiner(svg);
      });
      montants.forEach(apparaitre);
      return;
    }

    const observateur = new IntersectionObserver(
      (entrees) => {
        for (const entree of entrees) {
          if (!entree.isIntersecting) continue;
          const el = entree.target;
          if (el.classList.contains('mlo-trace')) {
            preparerTrace(el);
            requestAnimationFrame(() => dessiner(el));
          } else {
            apparaitre(el);
          }
          observateur.unobserve(el);
        }
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
    );

    traces.forEach((svg) => observateur.observe(svg));
    montants.forEach((el) => observateur.observe(el));

    /* -------------------------------------------------------------- */
    /* 3. Le mot défilant se repose hors écran                         */
    /* -------------------------------------------------------------- */

    if (rotations.length > 0) {
      const veille = new IntersectionObserver(
        (entrees) => {
          for (const entree of entrees) {
            entree.target.style.animationPlayState = entree.isIntersecting
              ? 'running'
              : 'paused';
          }
        },
        { threshold: 0 }
      );
      rotations.forEach((piste) => veille.observe(piste));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', activer, { once: true });
  } else {
    activer();
  }

  // L'éditeur de thème recharge les sections : on réarme ce qui apparaît.
  document.addEventListener('shopify:section:load', activer);
})();
